// extracted by mini-css-extract-plugin
module.exports = {"reservation-note":"reservation-note__9Nlw6","link":"link__1SJub"};